import { z } from 'zod'

const clientSchema = z.object({
  NEXT_PUBLIC_API_URL: z.string().url(),
  NEXT_PUBLIC_APP_ENV: z.enum(['local', 'dev', 'staging', 'production']),
  // CLERK_SECRET_KEY is deliberately not validated here — it's server-only and
  // @clerk/nextjs reads process.env.CLERK_SECRET_KEY directly wherever it needs it
  // (middleware, server components). This file's `env` export is safe to import from
  // client components; a server-only secret has no business being in that object.
  NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string().min(1),
})

export const env = clientSchema.parse({
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
})
